export default class Clickable {

  constructor() {
    this.bind();
  }

  bind() {
    document.addEventListener('click', this.click.bind(this));
  }

  click(e) {
    let el = e.target;

    // Any link inside the clickable element
    if (el.nodeName === 'A' && !el.dataset.clickableTarget) {
      return;
    }

    // Get data-clickable "parent"
    while (el && (!el.dataset || el.dataset.clickable === undefined)) {
      el = el.parentNode;
    }
    // or not…
    if(!el) {
      return false;
    }

    // Get target
    const link = el.querySelector('[data-clickable-target]');

    if (!link || !link.href) {
      return false;
    }

    e.preventDefault();

    let external = link.hasAttribute('target');

    //Middle click, cmd click, and ctrl click
    if (e.which > 1 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
      external = true;
    }

    if(external) {
      window.open(link.href);
    } else {
      window.location = link.href;
    }
  }
}
